'use client';

import { useAppStore } from '@/stores/app-store';
import { adminTranslations } from './admin-translations';

/**
 * Hook for admin UI translations.
 *
 * Usage:
 *   const t = useAdminT();
 *   t('action.save')            // 'บันทึก' in TH, fallback key in EN
 *   t('action.save', 'Save')    // 'บันทึก' in TH, 'Save' in EN
 *   t('nav.dashboard')          // 'แดชบอร์ด' in TH
 */
export type AdminTranslationFunction = (
  key: string,
  fallback?: string
) => string;

export function useAdminT() {
  const locale = useAppStore((s) => s.adminLocale);
  const dict = adminTranslations[locale];

  return function t(key: string, fallback?: string): string {
    return dict[key] ?? fallback ?? key;
  };
}
